export default __webpack_public_path__ + "static/building-aefa4d23364a517232b652a1c65bd10b.webp";